/**
 * Errors API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Redirect error codes: - `gbdfl_photo_not_found` - Verification photo not found in GBDFL. - `gbdfl_face_not_matched` - User\'s photo does not match the reference photo. - `gov_service_unavailable` - GOV service is unavailable. - `gbdfl_person_under_18_years` - User is under 18 years old. - `sms_limit_exceeded` - Exceeded the number of sent SMS. - `sms_code_attempts_exceeded` - Exceeded the number of SMS code entry attempts. - `liveness_attempts_exceeded` -  Exceeded the number of liveness check attempts. - `iin_not_found` - IIN not found in GBDFL. - `access_denied` - User clicked \"deny\" on the consent page. - `auth_iin_step_cancelled` - User canceled the session on the IIN input page. - `auth_sms_code_cancelled` - User canceled the session on the SMS code input page. - `auth_liveness_step_cancelled` - User canceled the session on the liveness check page. - `auth_bin_step_cancelled` - User canceled the session on the BIN input page. - `esign_is_blocked` -  Digital signature is blocked. - `esign_is_blocked_and_ready_to_reset -  Digital signature is blocked and ready to reset. - `esign_error` - Signing with esign unavailable. - `liveness_qr_expired` - Liveness QR expired. - `unauthorized` - Invalid sessionId or the link has expired. - `server_error` - Internal server error. - `network_connectivity_error` - Network connectivity error. - `liveness_error` - Unexpected liveness error. - `device_error` - Camera unavailable or device not supported 
 */
export enum OauthRedirectErrorCode {
    gbdfl_photo_not_found = 'gbdfl_photo_not_found',
    gbdfl_face_not_matched = 'gbdfl_face_not_matched',
    gov_service_unavailable = 'gov_service_unavailable',
    gbdfl_person_under_18_years = 'gbdfl_person_under_18_years',
    sms_limit_exceeded = 'sms_limit_exceeded',
    sms_code_attempts_exceeded = 'sms_code_attempts_exceeded',
    liveness_attempts_exceeded = 'liveness_attempts_exceeded',
    iin_not_found = 'iin_not_found',
    access_denied = 'access_denied',
    auth_iin_step_cancelled = 'auth_iin_step_cancelled',
    auth_sms_code_cancelled = 'auth_sms_code_cancelled',
    auth_liveness_step_cancelled = 'auth_liveness_step_cancelled',
    auth_bin_step_cancelled = 'auth_bin_step_cancelled',
    esign_is_blocked = 'esign_is_blocked',
    esign_is_blocked_and_ready_to_reset = 'esign_is_blocked_and_ready_to_reset',
    unauthorized = 'unauthorized',
    server_error = 'server_error',
    network_connectivity_error = 'network_connectivity_error',
    esign_error = 'esign_error',
    liveness_qr_expired = 'liveness_qr_expired',
    liveness_error = 'liveness_error',
    device_error = 'device_error'
}

